import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { DisplayCustomerPageRoutingModule } from './display-customer-routing.module';

import { DisplayCustomerPage } from './display-customer.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DisplayCustomerPageRoutingModule
  ],
  declarations: [DisplayCustomerPage]
})
export class DisplayCustomerPageModule {}
